import { useEffect } from 'react'
import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

const useFavicon = () => {
  useEffect(() => {
    const { dex } = getEnvAndDex()
    const { favicon } = getDexConfig(dex)

    const updateFavicon = (rel, url) => {
      let existingLink = document.querySelector(`link[rel='${rel}']`)
      if (existingLink) existingLink.parentNode.removeChild(existingLink)

      if (url) {
        const link = document.createElement('link')
        link.rel = rel
        link.href = `${url}?v=${new Date().getTime()}` // Cache busting
        document.head.appendChild(link)
      }
    }

    updateFavicon('icon', favicon) // Standard favicon
    updateFavicon('apple-touch-icon', favicon) // Apple Touch Icon for Safari/iOS
  }, [])
}

export default useFavicon
